import { render, staticRenderFns } from "./recomm.vue?vue&type=template&id=38541e6a&scoped=true&"
import script from "./recomm.vue?vue&type=script&lang=js&"
export * from "./recomm.vue?vue&type=script&lang=js&"
import style0 from "./recomm.vue?vue&type=style&index=0&id=38541e6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38541e6a",
  null
  
)

export default component.exports